import myAtupriConfig, { getLoggedInUserId } from '@src/config/myAtupriApi';
import { UsersApi } from '@src/generated';

import sampleSubscribedProducts from '@src/data/mock/myAtupri/subscribedProducts.json';
import sampleEffectiveDate from '@src/data/mock/myAtupri/effectiveDate.json';

class UserService {
    constructor() {
        this.api = new UsersApi(myAtupriConfig);
    }

    loadSubscribedProducts(submission = undefined) {
        const userId = getLoggedInUserId(submission);

        if (window.localStorage.getItem('mockLocalData') === 'true') {
            return Promise.resolve(sampleSubscribedProducts);
        } else {
            return this.api.getProductsForFamily(userId);
        }
    }

    loadEffectiveDates(insuranceNumber, newObjectId, currentObjectId = undefined) {
        if (window.localStorage.getItem('mockLocalData') === 'true') {
            return Promise.resolve(sampleEffectiveDate);
        } else {
            return this.api.getEffectiveDate(insuranceNumber, newObjectId, currentObjectId);
        }
    }
}

export default new UserService();
